export const REQUEST_GET_MAGNET_SALES_MESSAGE = "REQUEST_GET_MAGNET_SALES_MESSAGE";
export const SUCCESS_GET_MAGNET_SALES_MESSAGE = "SUCCESS_GET_MAGNET_SALES_MESSAGE";